export type IconType = 'success' | 'error';

export type NotificationData = {
  description: string;
  iconType: IconType;
  id: number;
  key: number;
  title: string;
  isAutoDismissFlag: boolean;
};

export const getSuccessNotificationData = (id: number, description: string): NotificationData => {
  return {
    description: description,
    iconType: 'success',
    id: id,
    key: id,
    title: 'Success',
    isAutoDismissFlag: true,
  };
};

export const getErrorNotificationData = (id: number, description: string): NotificationData => {
  return {
    description: description,
    iconType: 'error',
    id: id,
    key: id,
    title: 'Error',
    isAutoDismissFlag: false,
  };
};
